import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {AutoDistributionBoltIcon} from 'shells/icon/svg/auto-distribution-bolt-icon';

export const AUTO_RESOLVE_ID = 'auto-resolve';
export const SAME_ASSIGNEE_ID = 'same-assignee';

const AUTO_ASSIGN_OPTION_SHARED = {
    id: AUTO_RESOLVE_ID, // need a unique id which we set to null before sending it to the backend
    type: 'users',
    avatarUrl: '/include/images/icon-auto-assign_2x.png',
    isEnabled: true,
} as const;

export const AUTO_ASSIGN_OPTION = {
    ...AUTO_ASSIGN_OPTION_SHARED,
    name: 'Follow pipeline assignment rules',
} as const;

export const AUTO_ASSIGN_OPTION_COMPACT = {
    ...AUTO_ASSIGN_OPTION_SHARED,
    name: 'Auto assign',
} as const;

export const AUTO_DISTRIBUTE_OPTION = {
    value: AUTO_RESOLVE_ID, // need a unique id which we set to undefined/null before sending it to the backend
    label: (
        <div className='flex gap-4'>
            <AutoDistributionBoltIcon size={12} color={colors.grey} /> Auto distribute
        </div>
    ),
} as const;

export const UNASSIGNED_OPTION = {
    id: AUTO_RESOLVE_ID,
    name: 'Unassigned',
    type: 'users',
    avatarUrl: '/include/images/icon-auto-assign_2x.png',
    isEnabled: true,
} as const;

const SAME_ASSIGNEE_OPTION_SHARED = {
    id: SAME_ASSIGNEE_ID,
    type: 'users',
    avatarUrl: '/include/images/icon-auto-assign_2x.png',
    isEnabled: true,
};

export const SAME_ASSIGNEE_OPTION = {
    ...SAME_ASSIGNEE_OPTION_SHARED,
    name: 'Same as contact assignee',
} as const;

export const SAME_ASSIGNEE_OPTION_COMPACT = {
    ...SAME_ASSIGNEE_OPTION_SHARED,
    name: 'Same assignee',
} as const;
